<template>
  <div class="card">
    <div class="card card-custom" >
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('setting.normalization') }}</h3>
        </div>
      </div>
      <form class="form" @submit.prevent="submitForm">
        <div class="modal-content">
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Input
                  containerClass="col-12 mt-auto mb-10"
                  :name="`${id}-host`"
                  type="text"
                  :label="$t('setting.ifu')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('setting.ifu')"
                  v-model="formData.ifu"
              />

              <Input
                  containerClass="col-12 col-md-12 mt-auto mb-10"
                  :name="`${id}-username`"
                  type="text"
                  :label="$t('setting.token_Api')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('setting.token_Api')"
                  v-model="formData.key"

              />
              <Select2
                  v-if="canCreate"
                  :is-required="true"
                  containerClass="col-12 mt-auto mb-10"
                  :multiple="false"
                  :show-search="true"
                  :selectClass="'form-select form-control-lg form-select-solid'"
                  name="taxe"
                  :label="$t('setting.tax')"
                  label-class="form-label"
                  :placeholder="$t('setting.tax')"
                  v-model="formData.tax"
              >
                <option v-for="tax in taxGroups" :key="tax.id" :value="tax.id">
                  {{ tax.name }}
                </option>
              </Select2>

            </div>
          </div>
          <div v-if="canCreate" class="modal-footer">
            <Button
                v-if="$can(abilities.REMIND_CONFIG_CREATE)"
                btn-class="btn-sm me-3"
                type="submit"
                id="submit_btn"
                btn-text="button.save"
                size="7px 30px"
                :is-loading="processing"
            />
          </div>
          <div v-else class="modal-footer">
            <Button
                btn-class="btn-sm me-3"
                type="submit"
                id="submit_btn"
                btn-text="button.validate"
                size="7px 30px"
                :is-loading="loading"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import {computed, onMounted, ref,watch} from "vue";
import Input from "@/components/Input.vue";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import i18n from '@/plugins/i18n';
import {useStore} from "vuex";
import abilities from "@/composables/abilities";
import Select2 from "@/components/Select2.vue";
import sygmefAxios from "@/services/sygmefAxios";

const store = useStore()
const processing = ref(false)
const token =  import.meta.env.VITE_APP_MECEF_API_TOKEN
const taxGroups = ref([])
const typeInvoices = ref([])

const formData = ref({
  id: null,
  key: '',
  ifu: '',
  tax: '',
  automatic: '',
  society: '',

})
const canCreate = ref(false)
const loading = ref(false)

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])
const normalization = computed(() => store.getters['normalization/getNormalization'])


watch(() => currentSociety.value, (value) => {
  if(value?.id) {
    formData.value.society = value?.id
  }
})

watch(() => normalization.value, (value) => {
  let normalizationConfig = normalization.value[0];

  formData.value = {
    id: normalizationConfig?.id || null,
    key: normalizationConfig?.data?.key || '',
    ifu: normalizationConfig?.data?.ifu || '',
    tax: normalizationConfig?.data?.tax ,
    automatic: normalizationConfig?.automatic || false,
    society: normalizationConfig?.society || '',
  };

  if(normalizationConfig?.data?.key && normalizationConfig?.data?.ifu) {
    fetchTaxGroups()
  }
});

watch(() => [formData.value.key, formData.value.ifu], (value) => {
  if(!formData.value.key || !formData.value.ifu) {
    canCreate.value = false
  }
})


const submitForm = () => {
  if (canCreate.value) createNormalization()
  else fetchTaxGroups()
}
function fetchTaxGroups() {
  loading.value = true
  window.sygmefAxios.get('info/taxGroups', {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      Authorization: `Bearer ${formData.value.key}`
    },
  })
      .then(res => {
        canCreate.value = true
        taxGroups.value = Object.entries(res.data).map(([key, value]) => ({
          id: key,
          name: `${key}`
        }))
      })
      .catch(err => {
        window.toastr['error']($t('normalize_invalidate_token'))
      })
      .finally(() => loading.value = false)
}
function loadNormalization(){
  store.dispatch('normalization/loadNormalization')
};
function createNormalization() {
  processing.value = true

  const payload = {
    id: formData.value.id,
    key: formData.value.key,
    automatic: formData.value.automatic ?? false,
    society_id: formData.value.society ,
    data: {
      ifu: formData.value.ifu,
      tax: formData.value.tax,
      key: formData.value.key,
      tokenApi: null,
    }
  }
  store.dispatch('normalization/storeNormalization', payload)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.config_success"))

      })
      .catch(err => {
      })
      .finally(() => processing.value = false)
}


onMounted(() => {
  loadNormalization()
})
</script>


